const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** Returns true if value is a plausible email address. */
export function isValidEmail(value: string): boolean {
  return EMAIL_RE.test(value.trim());
}

/**
 * Returns true if endDate >= startDate (ISO "YYYY-MM-DD").
 * Returns true if either value is empty (incomplete input — defer to required validation).
 */
export function isEndDateValid(startDate: string, endDate: string): boolean {
  if (!startDate || !endDate) return true;
  return endDate >= startDate;
}

/** Returns true if index is within bounds [0, length). */
export function isValidSlotIndex(index: number, length: number): boolean {
  return index >= 0 && index < length;
}
